<app-deprecated-modal-form
    #filterModal
    id="filter-modal"
    [form]="TimeOffReportFilter"
    label="apply"
    headerText="filter"
    thin="true"
    (save)="onFilter(TimeOffReportFilter.filters)"
>
    <app-time-off-report-filter-form
        [timeOffTypes]="timeOffTypes"
        [selectedTimeOffTypeId]="selectedTimeOffType?.id"
        #TimeOffReportFilter
    ></app-time-off-report-filter-form>
</app-deprecated-modal-form>

<div class="page-container" [class.loading]="isLoading">
    <app-header [back]="true" title="reporting.reports.timeOffBalancesReport">
        <div class="buttons">
            <ui-button type="outline" (click)="filterModal.show()" style="float: right">{{
                'filter' | translate
            }}</ui-button>
            <ui-button type="primary" [matMenu]="exportMenu">
                {{ 'export' | translate }} <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="onExport('csv')">{{ 'export-as-csv' | translate }}</button>
                <button mat-menu-item (click)="onExport('xlxs')">{{ 'export-as-xlsx' | translate }}</button>
            </mat-menu>
        </div>
    </app-header>
    <h4 class="time-off-type">
        {{
            'reporting.reports.dateRange'
                | translate
                    : { startDate: (startDate | appDate: 'mediumDate'), endDate: (endDate | appDate: 'mediumDate') }
        }}
    </h4>
    <h4 class="time-off-type">
        {{ 'reporting.reports.timeOffType' | translate: { type: selectedTimeOffType?.name } }}
    </h4>
    <h4 class="time-off-type">
        {{
            'reporting.reports.units'
                | translate
                    : { unit: ((selectedTimeOffType?.displayInHours ? 'dateTime.hours' : 'dateTime.days') | translate) }
        }}
    </h4>
    <h4 class="time-off-type">
        {{
            'reporting.reports.pendingRequests'
                | translate: { requestStatus: ((includePending ? 'included' : 'excluded') | translate) }
        }}
    </h4>
    <h4 class="time-off-type">
        {{ 'reporting.reports.timeOffBalanceReportDescription' | translate }}
    </h4>

    <div *ngIf="report && report.data.sheets && report.data.sheets.length; else emptyState" class="report-body">
        <app-report-table #reportTable [report]="report"></app-report-table>
    </div>
</div>

<ng-template #emptyState>
    <div class="ui segment">
        <app-empty-state label="reporting.reports.thereIsNoTimeOffDataToReportOn"></app-empty-state>
    </div>
</ng-template>
